import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import HomePage from "@/pages/HomePage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CheckoutCancelPage from "@/pages/CheckoutCancelPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import LegalNoticePage from "@/pages/LegalNoticePage";
import OrderTrackingPage from "@/pages/OrderTrackingPage";
import AllergensPage from "@/pages/AllergensPage";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacidad" element={<PrivacyPolicyPage />} />
            <Route path="/terminos" element={<TermsPage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            <Route path="/reembolsos" element={<RefundPolicyPage />} />
            <Route path="/aviso-legal" element={<LegalNoticePage />} />
            <Route path="/alergenos" element={<AllergensPage />} />
            <Route path="/order/:orderId" element={<OrderTrackingPage />} />
          </Routes>
          <CookieBanner />
          <Toaster position="top-right" />
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
